import { render, staticRenderFns } from "./AttendanceClassV3.vue?vue&type=template&id=32a56cb3&scoped=true"
import script from "./AttendanceClassV3.vue?vue&type=script&lang=js"
export * from "./AttendanceClassV3.vue?vue&type=script&lang=js"
import style0 from "./AttendanceClassV3.vue?vue&type=style&index=0&id=32a56cb3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a56cb3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a56cb3')) {
      api.createRecord('32a56cb3', component.options)
    } else {
      api.reload('32a56cb3', component.options)
    }
    module.hot.accept("./AttendanceClassV3.vue?vue&type=template&id=32a56cb3&scoped=true", function () {
      api.rerender('32a56cb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/attendance-v2/AttendanceClassV3.vue"
export default component.exports